<template>
  <div
    class="card card-subscribables student-card"
    :class="{ 'menu-page': menuPage }"
  >
    <div
      class="student-card__header"
    >
      <slot
        name="header"
      />
    </div>

    <div
      class="student-card__content"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'StudentCard',
  props: {
    title: {
      required: false,
      type: [String, null],
      default: null,
    },
    onlyCard: {
      required: false,
      type: Boolean,
      default: false,
    },
    collapsable: {
      required: false,
      type: Boolean,
      default: true,
    },
    menuPage: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      collapsed: false,
      width: null,
    }
  },
  mounted () {
    // listener to watch the current width of the window
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize () {
      this.width = window.innerWidth
    },
  },
}

</script>

<style scoped lang="scss">
  .student-card {
    display: flex;
    flex-direction: column;
    height: inherit;

    &__header {
      align-content: end;
      margin-bottom: 5px;
      border-bottom:1px solid #EEEEEE;
    }

    &__content {
      flex: 1 1 auto;
      overflow-y: auto;
    }

    .collapse-caret {
      margin-right: 5px;
      width: 10px;
    }
  }

  .menu-page {
    background-color: #e0e5f1;
  }
</style>
